module.exports = __webpack_public_path__ + "static/media/idm_thumbnail.2c146ffc.png";